module.exports = __webpack_public_path__ + "img/card_chinese.9d6e220b.png";